export default __webpack_public_path__ + "static/media/login.292990c3.jpg";